import commons from './commons';

const Element = Object.freeze({
  Content: {
    _name: "Content",
    input: "description",
    content: "enter your text"
  },
  Image: {
    _name: "Image",
    input: "image",
    url: null,
    item: {
      formType: "design",
      input: "imageUpload",
      fieldName: "imageSource"
    }
  },
  Space: {
    _name: "Empty Space",
    input: "empty"
  },
  Custom: {
    _name: "Control/Input",
    input: "custom",
    custom: true,
    beta: true
  },
  Button: {
    _name: "Button",
    input: "button",
    beta: true
  }
});
const elements = Object.freeze([
  Element.Content,
  Element.Image,
  Element.Space,
  Element.Custom,
  Element.Button
]);
/**
 * 
 * @param {String} elementInput 
 * @returns 
 */
const isElement = (elementInput) => elements.findIndex((x) => x.input === elementInput) > -1;
/**
 * 
 * @param {Array} items 
 * @param {String} informationId 
 * @returns 
 */
const findInformationByIdInternal = (items, informationId) =>
  Array.isArray(items) && items.some((item) => {
    if (item.input === 'section') {
      if (item.type === 'tab') {
        return Array.isArray(item.tabs) && item.tabs.some((tab) => tab.design && findInformationById(tab.design, informationId));
      } else if (item.design) {
        return findInformationById(item.design, informationId);
      }
    } else if (
      item &&
      item.id &&
      item.input !== 'description' &&
      item.input !== 'image' &&
      item.input !== 'empty' &&
      item.input !== 'button' &&
      item.input !== 'custom'
    ) {
      if (Array.isArray(item.fields)) {
        const isField = item.fields.some((field) => field.id === informationId && !field.hide);
        if (isField) {
          return true;
        }
      }
      return item.id === informationId;
    }
  });
/**
 * 
 * @param {Object} form 
 * @param {String} informationId 
 * @returns 
 */
const findInformationById = (form, informationId) =>
  form && Array.isArray(form.rows) && form.rows.some((x) =>
    x && x.items && findInformationByIdInternal(x.items, informationId)
  );
/**
 * 
 * @param {Object} canvas 
 * @param {String} informationId 
 * @param {Object} payload 
 * @returns 
 */
const getFormsByInformationId = (canvas, informationId, payload) => {
  let res = [];
  const standardActivities = Array.isArray(canvas && canvas.standardActivities)
    ? Array.isArray(payload && payload.excluded)
      ? canvas.standardActivities.filter((x) => !payload.excluded.some((y) => y === x.id))
      : canvas.standardActivities
    : null;
  const activities = Array.isArray(canvas && canvas.activities)
    ? Array.isArray(payload && payload.excluded)
      ? canvas.activities.filter((x) => !payload.excluded.some((y) => y === x.id))
      : canvas.activities
    : null;
  const getForms = (list, type) => {
    const forms = list.filter((x) =>
      x && x.design && findInformationById(x.design, informationId)
    );
    if (forms && forms.length) {
      res = res.concat(forms.map((x) => ({
        id: x.id,
        name: x.name,
        emoji: x.emoji,
        color: x.color,
        type: type
      })));
    }
  }
  Array.isArray(standardActivities) && getForms(standardActivities, 'standardActivity');
  Array.isArray(activities) && getForms(activities, 'activity');
  return res;
}
/**
 * 
 * @param {Array} standardActivities 
 * @returns 
 */
const isAutoForms = (standardActivities) => {
  const defaultForm = standardActivities.find((x) => x.id === 'createEditView');
  if (defaultForm && defaultForm.design) {
    return false;
  } else {
    const createForm = standardActivities.find((x) => x.id === 'create');
    const editForm = standardActivities.find((x) => x.id === 'edit');
    const viewForm = standardActivities.find((x) => x.id === 'view');
    if (
      (createForm && createForm.design) &&
      (editForm && editForm.design) &&
      (viewForm && viewForm.design)
    ) {
      return false;
    }
  }
  return true;
}
/**
 * 
 * @param {String} input 
 * @returns 
 */
const isFormElement = (input) => ['description', 'image', 'empty', 'custom', 'button', 'section'].indexOf(input) > -1;
/**
 * 
 * @param {Object} form 
 * @param {Array} information 
 */
const addInformationFieldsToFormDesign = (form, information) => {
  Array.isArray(form.rows) && form.rows.forEach((row) => {
    Array.isArray(row.items) && row.items.forEach((item) => {
      if (item.input === 'section') {
        if (item.type === 'tab') {
          Array.isArray(item.tabs) && item.tabs.forEach((tab) => {
            tab.design && addInformationFieldsToFormDesign(tab.design, information);
          });
        } else {
          item.design && addInformationFieldsToFormDesign(item.design, information);
        }
      } else if (item.id && !isFormElement(item.input)) {
        const res = information.find((x) => x.id === item.id);
        if (res) {
          const informationItem = _.cloneDeep(res);
          if (informationItem.type == 14) {
            if (!(Array.isArray(informationItem.fields) || informationItem.field.length)) {
              item.fields = [];
            } else if (!(Array.isArray(item.fields) || (item.fields && item.fields.length))) {
              item.fields = informationItem.fields.map((y) => ({ id: y.id }));
            } else {
              /* add fields */
              informationItem.fields
                .filter((x) => !item.fields.some((y) => y.id === x.id))
                .forEach((x) => {
                  item.fields.splice(
                    informationItem.fields.findIndex((y) => y.id === x.id),
                    0,
                    { id: x.id }
                  );
                });
            }
          } else if (informationItem.type == 15) {
            item.design && Array.isArray(informationItem.fields) && addInformationFieldsToFormDesign(item.design, informationItem.fields);
          }
        }
      }
    });
  });
}
/**
 * 
 * @param {Object} canvas 
 */
const addInformationFieldsToForms = (canvas) => {
  if (Array.isArray(canvas.information)) {
    Array.isArray(canvas && canvas.standardActivities) && canvas.standardActivities.forEach((x) => {
      x.design && addInformationFieldsToFormDesign(x.design, canvas.information);
    });
    Array.isArray(canvas && canvas.activities) && canvas.activities.forEach((x) => {
      x.design && addInformationFieldsToFormDesign(x.design, canvas.information);
    });
  }
}
/**
 * 
 * @param {Object} canvas 
 * @param {string} formActivityId 
 * @param {string} formActivityType 
 * @returns 
 */
const getActivityFormInformation = (canvas, formActivityId, formActivityType) => {
  try {
    if (formActivityType === 'standardActivity') {
      const res = canvas.standardActivities.find((x) => x.id === formActivityId);
      if (res && res.design && res.design.rows) {
        const information = commons.classificationInformation(res.design.rows, canvas.information);
        return information.length ? information : null;
      }
      if (formActivityId === 'createEditView') {
        return canvas.information;
      } else if (['create', 'edit', 'view'].includes(formActivityId)) {
        return getActivityFormInformation(canvas, 'createEditView', 'standardActivity');
      } else if (formActivityId === 'quickView') {
        return getActivityFormInformation(canvas, 'view', 'standardActivity');
      }
    } else if (formActivityType === 'activity') {
      const res = canvas.activities.find((x) => x.id === formActivityId);
      if (res && res.design && res.design.rows) {
        return commons.classificationInformation(res.design.rows, canvas.information);
      }
    }
  } catch(err) {
    console.warn(err); 
    return null;
  }
}
/**
 * 
 * @param {Object} item 
 * @returns 
 */
const isFormContainsInformationInternal = (item) => {
  if (Array.isArray(item && item.items)) {
    return item.items.some((x) => {
      if (x.input === 'section' && x.type === 'tab' && Array.isArray(x.tabs)) {
        return x.tabs.some((y) => y.design && isFormContainsInformation(y.design.rows));
      } else if (x.input === 'section') {
        return x.design && isFormContainsInformation(x.design.rows);
      } else {
        return !isElement(x.input);
      }
    });
  }
  return false;
}
/**
 * 
 * @param {Array} rows 
 * @returns 
 */
const isFormContainsInformation = (rows) => {
  return Array.isArray(rows) ? rows.some((x) => isFormContainsInformationInternal(x)) : false;
}
/**
 * 
 * @param {Object} item 
 * @returns 
 */
const isValidFormInternal = (item) => {
  if (!Array.isArray(item && item.items)) return false;

  return item.items.some((x) => {
    if (x.input === "section") {
      if (x.type === "tab") {
        return Array.isArray(x.tabs) && x.tabs.length > 0 && x.tabs.some((y) => y.design && isValidForm(y.design.rows));
      }
      return x.design && isValidForm(x.design.rows);
    }
    return !!x.id;
  });
}
/**
 * 
 * @param {Array} rows 
 * @returns 
 */
const isValidForm = (rows) => {
  return Array.isArray(rows) ? rows.some((x) => isValidFormInternal(x)) : false;
}
/**
 * Design-time dependency scan for a COMPUTED (information-formula) field placed on a form:
 * the information fields its formula reads that are NOT on this form. Without them the form
 * can only show the field's stored value — it cannot recompute locally while editing (the
 * authoritative recompute happens on the server when the entry is performed).
 * Handles both authoring styles: {{entry.fieldName...}} template refs (the current editor;
 * segment 1 names a top-level module field) and legacy field('Display Name') calls — a
 * summ(..., field('Table')) aggregate is caught through its inner field() ref. column('X')
 * is a within-row reference to the host table, which is on the form by definition.
 * Names that resolve to no module field are skipped (invalid refs are the consistency
 * checker's problem, not this notice's).
 * @param {Object} form the whole activity design ({ rows })
 * @param {Array} information the module information (working copy)
 * @param {String} formula the computed information's formula
 * @returns {Array} referenced information items missing from the form (possibly empty)
 */
const computedFormulaMissingDependencies = (form, information, formula) => {
  if (!form || !Array.isArray(information) || typeof formula !== 'string' || !formula) {
    return [];
  }
  const referenced = new Map();
  const refer = (item) => item && item.id && referenced.set(item.id, item);

  /* {{entry.price}} / {{entry.items.amount}} (dep = the table) — resolved by fieldName */
  const templateRe = /{{\s*(?:entry|form)\.([^}.]+)/g;
  let match;
  while ((match = templateRe.exec(formula))) {
    const fieldName = match[1].trim();
    refer(information.find((x) => x && x.fieldName === fieldName));
  }

  /* field('Price') — resolved by display name; field(['A','B']) drills a table, so only the
     first name is the top-level dependency (mirrors the formula engine's trigger extraction) */
  const fieldRe = /\bfield\(\s*\[?\s*'((?:[^'\\]|\\.)*)'/g;
  while ((match = fieldRe.exec(formula))) {
    const displayName = match[1].replace(/\\'/g, "'").replace(/\\\\/g, '\\');
    refer(information.find((x) => x && x.displayName === displayName));
  }

  return [...referenced.values()].filter((x) => !findInformationById(form, x.id));
}
/**
 *
 * @param {Array} activities
 * @param {string} activityId
 * @returns
 */
const getClassificationByActivityId = (activities, activityId) => {
  if (Array.isArray(activities)) { 
    const findActivity = activities.find(x => x.id === activityId);
    return findActivity && findActivity.classification;
  }
}
/**
 * 
 * @param {Array} activities 
 * @param {string} activityId 
 * @param {Array} information 
 * @returns 
 */
const getDefaultClassificationByActivityId = (activities, activityId, information) => {
  let classification = getClassificationByActivityId(activities, activityId);
  if (classification) {
    return classification;
  }

  if (["create", "edit"].includes(activityId)) {
    if (Array.isArray(activities)) {
      classification = getClassificationByActivityId(activities, "createEditView");
      if (classification) {
        return classification;
      }
    }

    if (Array.isArray(information)) {
      return [...information];
    }
  } else if (activityId === "createEditView" && Array.isArray(information)) {
    return [...information];
  }
}

export default {
  Element: Element,
  elements: elements,
  isElement: isElement,
  getFormsByInformationId: getFormsByInformationId,
  isAutoForms: isAutoForms,
  isFormElement: isFormElement,
  addInformationFieldsToForms: addInformationFieldsToForms,
  getActivityFormInformation: getActivityFormInformation,
  isFormContainsInformation: isFormContainsInformation,
  isValidForm: isValidForm,
  computedFormulaMissingDependencies: computedFormulaMissingDependencies,
  getClassificationByActivityId: getClassificationByActivityId,
  getDefaultClassificationByActivityId: getDefaultClassificationByActivityId
}